import React from "react";
import Swal from "sweetalert2";
import { CModal } from '@coreui/react';
import { generateAxiosInstanceCommonFileUpload } from "../hooks/useAuthorizedRequestForFileUpload";

const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();

export const getLink = async (name, body, setLink) => {
    return authorizedAxiosCommonFileUpload.post("/uploadfile-v2", body)
        .then((res) => {
            if (setLink) {
                setLink((prevData) => {
                    return {
                        ...prevData,
                        [name]: res.data.result
                    }
                })
            }
            return res.data.result;
        })
        .catch((err) => {
            const errorMsg = err.response?.data?.error || "Something went wrong!";
            Swal.fire({ text: errorMsg });
            return null;
        });
};

export const validateQuestionData = (questionData, isSet, setQuestionList) => {
    let errorCount = 0;
    const errorquestionIds = [];

    const questions = Array.isArray(questionData) ? questionData : [questionData];

    const updatedQuestionData = questions.map((question, idx) => {
        const { question: questionText, options, answer, no } = question;
        let errorMessage = '';

        if (!questionText || !options || !answer) {
            errorMessage = "Missing required fields: question, options, answer.";
            errorCount++;
            errorquestionIds.push(no);
        } else if (
            typeof questionText !== 'string' || questionText.trim() === '' ||
            !isValidOption(options, 'a') ||
            !isValidOption(options, 'b') ||
            !isValidOption(options, 'c') ||
            !isValidOption(options, 'd') ||
            typeof answer !== 'string' || answer.trim() === ''
        ) {
            errorMessage = "Invalid or empty field values.";
            errorCount++;
            errorquestionIds.push(question.no);
        }

        return {
            ...question,
            error: errorMessage,
        };
    });

    if (isSet) {
        setQuestionList(updatedQuestionData);
    }

    return {
        errorquestionIds: errorquestionIds,
        errorCount: errorCount
    };
};


const isValidOption = (options, key) => {
    const optionKeys = Object.keys(options);
    const validKey = optionKeys.find(optionKey =>
        optionKey.toLowerCase() === key.toLowerCase() ||
        optionKey.toLowerCase().includes(`${key.toLowerCase()}`)
    );
    const value = options[validKey];
    return !!validKey && (typeof value === 'string' && value.trim() !== '' || typeof value === 'number');
};

// data is initialFormState useState variable
export const handleQuestionUpdate = (question, data, setData) => {
    const isSelected = data.questionData.some(q => q.no === question.no);
    if (isSelected) {
        const updatedQuestionData = data.questionData.filter(q => q.no !== question.no);
        setData(prevState => ({
            ...prevState,
            questionData: updatedQuestionData
        }));
    } else {
        setData(prevState => ({
            ...prevState,
            questionData: [...prevState.questionData, question]
        }));
    }
};

// Data is a useState
export const handleSelectAll = (questionList, data, setData) => {
    setData(prevState => {
        const allSelected = data.questionData.length === questionList.length;
        return {
            ...prevState,
            questionData: allSelected ? [] : [...questionList]
        }
    })
};

export const isErrorQuestion = (errorQuestions, question) => {
    return errorQuestions.errorquestionIds.includes(question.no);
};

export const onViewImage = (imgSrc, setModalImageSrc, setVisibleImage) => {
    setModalImageSrc(imgSrc);
    setVisibleImage(true);
};

export const SolutionModal = ({ visibleSolution, setVisibleSolution, modalData }) => {
    return (
        <CModal
            visible={visibleSolution}
            onClose={() => setVisibleSolution(false)}
            aria-labelledby="LiveDemoExampleLabel"
        >
            <div className="book book-modal">
                <div className='table-header-like'>Solution</div>
                <div className="page" dangerouslySetInnerHTML={{
                    __html: `<style>
                        .page p { display: inline; }
                        .page img { 
                            width: initial !important;
                            max-width: 100% !important;
                            height: auto !important;
                            vertical-align: middle;
                            margin: 0 4px;
                        }
                    </style>
                    <div class="ck-content">${modalData}</div>`
                }}></div>
                <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleSolution(false)}>
                    Close
                </button>
            </div>
        </CModal>
    );
};

export const ImageModal = ({ visibleImage, setVisibleImage, modalImageSrc }) => {
    return (
        <CModal
            visible={visibleImage}
            onClose={() => setVisibleImage(false)}
            aria-labelledby="LiveDemoExampleLabel"
        >
            <div className="book book-modal">
                <div className='table-header-like'>Image</div>
                {modalImageSrc && (
                    <div className='page' dangerouslySetInnerHTML={{
                        __html: `<style>
                            .page p { display: inline; }
                            .page img { 
                                width: initial !important;
                                max-width: 100% !important;
                                height: auto !important;
                                vertical-align: middle;
                                margin: 0 4px;
                            }
                            .page br { display: none; }
                        </style>${modalImageSrc}`
                    }}></div>
                )}
                <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                    Close
                </button>
            </div>
        </CModal>
    );
};


export const QuestionFilter = ({ question, children }) => {
    // Check if the question has unwanted double quotes
    const hasUnwantedDoubleQuotes = (value) => {
        if (typeof value !== 'string') return false;

        const regex = /(?:^|[^<])"(?![^<>]*<\/img>)/g;
        const imgTagWithSrc = /<img.*?src=".*?".*?>/g;
        return regex.test(value) && !imgTagWithSrc.test(value);
    };

    const hasDoubleQuotes = ['q_level', 'q_type', 'question', 'option_a', 'option_b', 'option_c', 'option_d', 'ans']
        .some(key => hasUnwantedDoubleQuotes(question[key]));

    if (hasDoubleQuotes) return null;

    return <>{children}</>;
};

export const Loader = ({ loading }) => {
    if (!loading) return null;

    return (
        <div className="modal-loader-overlay">
            <div className="modal-loader-content">
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                <p className="loader-message">Loading...</p>
            </div>
        </div>
    );
};










// Upload Exam Validation
export const validateUploadExamQuestionData = (questionData, isSet, setQuestionList) => {
    let errorCount = 0;
    const errorquestionIds = [];

    const questions = Array.isArray(questionData) ? questionData : [questionData];

    const updatedQuestionData = questions.map((question, idx) => {
        const { question: questionText, option_a, option_b, option_c, option_d, ans, q_id } = question;
        let errorMessage = '';

        if (!questionText || !option_a || !option_b || !option_c || !option_d || !ans) {
            errorMessage = "Missing required fields: question, options, ans.";
            errorCount++;
            errorquestionIds.push(q_id);
        } else if (
            typeof questionText !== 'string' || questionText.trim() === '' ||
            !isValidExamOption(option_a) ||
            !isValidExamOption(option_b) ||
            !isValidExamOption(option_c) ||
            !isValidExamOption(option_d) ||
            typeof ans !== 'string' || ans.trim() === ''
        ) {
            errorMessage = "Invalid or empty field values.";
            errorCount++;
            errorquestionIds.push(q_id);
        }

        return {
            ...question,
            error: errorMessage,
        };
    });

    if (isSet) {
        setQuestionList(updatedQuestionData);
    }

    return {
        errorquestionIds: errorquestionIds,
        errorCount: errorCount
    };
};

const isValidExamOption = (option) => {
    return (typeof option === 'string' && option.trim() !== '') || (typeof option === 'number' && !isNaN(option));
};


export const isErrorUploadExamQuestion = (errorQuestions, question) => {
    return errorQuestions.errorquestionIds.includes(question.q_id);
};





// Create Exam Validation
export const validateCreateExamQuestionData = (questionData, isSet, setQuestionList) => {
    let errorCount = 0;
    const errorquestionIds = [];

    const questions = Array.isArray(questionData) ? questionData : [questionData];

    const updatedQuestionData = questions.map((question, idx) => {
        const { question: questionText, option_a, option_b, option_c, option_d, ans, id } = question;
        let errorMessage = '';

        if (!questionText || !option_a || !option_b || !option_c || !option_d || !ans) {
            errorMessage = "Missing required fields: question, options, ans.";
            errorCount++;
            errorquestionIds.push(id);
        } else if (
            typeof questionText !== 'string' || questionText.trim() === '' ||
            !isValidExamOption(option_a) ||
            !isValidExamOption(option_b) ||
            !isValidExamOption(option_c) ||
            !isValidExamOption(option_d) ||
            typeof ans !== 'string' || ans.trim() === ''
        ) {
            errorMessage = "Invalid or empty field values.";
            errorCount++;
            errorquestionIds.push(id);
        }

        return {
            ...question,
            error: errorMessage,
        };
    });

    if (isSet) {
        setQuestionList(updatedQuestionData);
    }

    return {
        errorquestionIds: errorquestionIds,
        errorCount: errorCount
    };
};

export const isErrorCreateExamQuestion = (errorQuestions, question) => {
    return errorQuestions.errorquestionIds.includes(question.id);
};


export const cleanHtml = (html) => {
    if (!html) return '';

    // Replace &nbsp; with space
    html = html.replace(/&nbsp;/g, ' ');

    // Remove all tags except <img>
    html = html.replace(/<(?!img\b)[^>]*>/gi, '');

    return html.trim();
};